import React, { useState, useEffect } from "react";
import Header from "../header/header";
import Footer from "../footer/footer";
import Footer1 from "../footer/footer1";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { baseApiUrl } from "../../../services/api";


function ProfileInfo({ utilisateur }) {
  const [searchTerm, setSearchTerm] = useState("");
  const [categoriesOptions, setCategoriesOptions] = useState([]);
  const [category, setCategory] = useState("Toutes");
  const [projects, setProjects] = useState([]); // État pour stocker les projets
  const [currentUser, setCurrentUser] = useState(null); // État pour stocker l'utilisateur
  const imageUrl = utilisateur.photo
    ? baseApiUrl.defaults.baseURL + `/image/${utilisateur.photo}`
    : "default-image.jpg"; // Remplacer par une image par défaut si `images` est null
  const navigate = useNavigate();

  
  const truncateText = (text, wordLimit) => {
    if (typeof text !== 'undefined' && text !== null) {
      const words = text.split(" ");
      if (words.length > wordLimit) {
        return words.slice(0, wordLimit).join(" ") + "..."; // Tronque et ajoute "..."
      }
      return text; // Retourne le texte sans changement si le nombre de mots est inférieur à la limite
    } else {
      return ''; // Retourne une chaîne vide si text est undefined ou null
    }
  };
  

  const goToProfileDetail = () => {
    if (utilisateur.id) {
      // Vérifiez que l'ID est défini
      navigate(`/utilisateur/${utilisateur.id}`);
    } else {
      console.error("L'ID du profile est indéfini !");
    }
  };

  // const goToProjectDetail = (projectId) => {
  //     if (projectId) {
  //         navigate(`/projet/${projectId}`);
  //     } else { console.error("L'ID du projet est indéfini !");

  // } };

  // Filtrer les projets par le terme de recherche
  const filteredProjects = projects.filter((project) =>
    project.titre.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
     <div class="top-area">
                    
                         <div key={utilisateur.id}  utilisateur={utilisateur} className="author-area">
                   <div className="image" >                          
                    <img
                               src={imageUrl}
                               onClick={goToProfileDetail}
                               alt={utilisateur.prenom}
                               className="rounded-circle"
                               width="50"
                               height="50"
                             />
                           </div>
                           <div className="heading1 ml-20">
                             <h4>
                             {utilisateur.prenom}    
                                                   </h4>
                             <p className="mt-2">
                               {utilisateur.roles.length > 0
                                 ? utilisateur.roles.join(", ")
                                 : "Aucun rôle"}
                             </p>
                           </div>
                         </div>
                     
                     
                   </div>
  );
}

export default ProfileInfo;